import autosize from 'autosize'

/*
  TODO: We can remove this once all textareas have been converted to components
*/
$(document).ready(function () {
  // Don't autosize Terms & Conditions textareas when adopting a pet
  autosize(
    $('textarea').not(
      '.adoption textarea, .no-resize, .c-text-area, .c-form-input--textarea, .js-c-form-input--textarea'
    )
  )
})
